export default "__VITE_ASSET__59b939dc__"